<template>
  <div class="animated fadeIn" v-html="$t('Webportal.DataProtection.ContentVue2')">
  </div>
</template>

<script>
export default {
  name: 'DataProtection'
}
</script>

<style scoped>
  h5 {
    margin-top:1em
  }
  a {
    color: var(--color-primary);
  }
  a:hover {
    color: var(--color-primary);
  }
</style>